// extracted by mini-css-extract-plugin
module.exports = {"citySearch":"search-in-city_citySearch__2A3Di","headingLabel":"search-in-city_headingLabel__3PbKb"};